export const twContainer = 'tw:flex tw:flex-col tw:items-center tw:justify-center tw:py-16 tw:px-4 tw:text-center';

export const twIconWrapper = 'tw:text-[var(--color-text-tertiary)] tw:mb-4 tw:[&>svg]:tw:w-16 tw:[&>svg]:tw:h-16';

export const twTitle = 'tw:text-lg tw:font-medium tw:text-[var(--color-text-primary)] tw:mb-1';

export const twDescription = 'tw:text-sm tw:text-[var(--color-text-secondary)] tw:mb-4 tw:max-w-xs';
